import { createContext } from "react";

export const CreativeReviewContext = createContext({
  metadataComponent: () => <></>,
});
